// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TopNavigation_topNavigation__c2nxx {
  display: flex;
  align-items: center;
  align-self: stretch;
  gap: 6px;
  margin-left: 24px;
}

.TopNavigation_category__7rFD3 {
  display: flex;
  align-items: center;
  position: relative;
}

.TopNavigation_categoryButton__cMyCN {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 36px;
  padding: 0 12px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--m-nav-item);
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  transition: color 0.15s ease, background-color 0.15s ease;
}
.TopNavigation_categoryButton__cMyCN svg {
  font-size: 14px !important;
  color: currentColor;
  opacity: 0.65;
  transition: transform 0.15s ease, opacity 0.15s ease;
}
.TopNavigation_categoryButton__cMyCN:hover, .TopNavigation_categoryButton__cMyCN[aria-expanded=true] {
  color: var(--m-primary);
  background: var(--m-primary-subtle);
}
.TopNavigation_categoryButton__cMyCN:hover svg, .TopNavigation_categoryButton__cMyCN[aria-expanded=true] svg {
  opacity: 1;
}

.TopNavigation_activeCategory__jRDIo {
  color: var(--m-primary);
  background: var(--m-primary-subtle);
  font-weight: 600;
}
.TopNavigation_activeCategory__jRDIo svg {
  opacity: 1;
}

.TopNavigation_rotatedChevron__mcsnr {
  transform: rotate(180deg);
}

.TopNavigation_megaMenu__uHslB {
  position: fixed;
  top: 70px;
  z-index: 40;
  width: min(760px, 100vw - 32px);
  max-height: calc(100vh - 96px);
  overflow-y: auto;
  background: var(--m-header-background-color);
  border: 1px solid var(--m-border-color);
  border-radius: 12px;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.16), 0 3px 8px rgba(15, 23, 42, 0.08);
}
.TopNavigation_megaMenu__uHslB::before {
  content: "";
  position: absolute;
  top: -5px;
  left: var(--menu-arrow-left, 24px);
  width: 10px;
  height: 10px;
  background: var(--m-header-background-color);
  border-top: 1px solid var(--m-border-color);
  border-left: 1px solid var(--m-border-color);
  transform: rotate(45deg);
}

.TopNavigation_megaMenuInner__z5CIH {
  padding: 20px;
}

.TopNavigation_megaMenuHeading__18B3a {
  margin-bottom: 14px;
  padding: 0 8px 12px;
  border-bottom: 1px solid var(--m-border-color);
  color: var(--m-text);
  font-size: 16px;
  font-weight: 600;
}

.TopNavigation_megaMenuGrid__xcicp {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  align-items: start;
  gap: 18px;
}

.TopNavigation_megaMenuColumn__xkN9p {
  display: flex;
  flex-direction: column;
  gap: 28px;
  min-width: 0;
}

.TopNavigation_group__tjWg0 {
  min-width: 0;
  padding: 4px 4px 8px;
  list-style: none;
}

.TopNavigation_nestedGroup__WmKhu {
  padding: 10px 0 4px 14px;
}

.TopNavigation_groupTitle__07BHf {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--m-border-color);
  color: var(--m-text-muted);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
}

.TopNavigation_groupIcon__9w4E9 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: var(--m-primary-subtle);
  color: var(--m-icon-primary);
  font-size: 15px;
}

.TopNavigation_menuList__adKs9 {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
}

.TopNavigation_menuLink__5WVcC {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  padding: 8px 10px;
  border-radius: 6px;
  color: var(--m-text-muted);
  font-size: 13px;
  line-height: 1.3;
  text-decoration: none;
}
.TopNavigation_menuLink__5WVcC::before {
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  flex-shrink: 0;
  background: currentColor;
  opacity: 0.55;
}
.TopNavigation_menuLink__5WVcC:hover {
  color: var(--m-primary);
  background: var(--m-primary-subtle-hovered);
}
.TopNavigation_menuLink__5WVcC:hover::before {
  opacity: 1;
  background: var(--m-primary);
}

@media (max-width: 1399.88px) {
  .TopNavigation_megaMenu__uHslB {
    width: min(680px, 100vw - 32px);
  }
}
.TopNavigation_activeLink__sQJ6F {
  color: var(--m-primary);
  background: var(--m-primary-subtle);
  font-weight: 500;
}
.TopNavigation_activeLink__sQJ6F::before {
  opacity: 1;
  background: var(--m-primary);
}

@media (max-width: 1199.88px) {
  .TopNavigation_topNavigation__c2nxx {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/AppHeader/TopNavigation/TopNavigation.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yDACE;AAAJ;AAGE;EACE,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,oDACE;AAFN;AAME;EAEE,uBAAA;EACA,mCAAA;AALJ;AAOI;EACE,UAAA;AALN;;AAUA;EACE,uBAAA;EACA,mCAAA;EACA,gBAAA;AAPF;AASE;EACE,UAAA;AAPJ;;AAWA;EACE,yBAAA;AARF;;AAWA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,+BAAA;EACA,8BAAA;EACA,gBAAA;EACA,4CAAA;EACA,uCAAA;EACA,mBAAA;EACA,gFACE;AATJ;AAYE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,4CAAA;EACA,2CAAA;EACA,4CAAA;EACA,wBAAA;AAVJ;;AAcA;EACE,aAAA;AAXF;;AAcA;EACE,mBAAA;EACA,mBAAA;EACA,8CAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;AAXF;;AAcA;EACE,aAAA;EACA,2DAAA;EACA,kBAAA;EACA,SAAA;AAXF;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AAXF;;AAcA;EACE,YAAA;EACA,oBAAA;EACA,gBAAA;AAXF;;AAcA;EACE,wBAAA;AAXF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,8CAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAXF;;AAcA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,4BAAA;EACA,eAAA;AAXF;;AAcA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAXF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AAXF;AAaE;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,wBAAA;EACA,aAAA;AAXJ;AAcE;EACE,uBAAA;EACA,2CAAA;AAZJ;AAcI;EACE,UAAA;EACA,4BAAA;AAZN;;AAiBA;EACE;IACE,+BAAA;EAdF;AACF;AAiBA;EACE,uBAAA;EACA,mCAAA;EACA,gBAAA;AAfF;AAiBE;EACE,UAAA;EACA,4BAAA;AAfJ;;AAmBA;EACE;IACE,aAAA;EAhBF;AACF","sourcesContent":[".topNavigation {\n  display: flex;\n  align-items: center;\n  align-self: stretch;\n  gap: 6px;\n  margin-left: 24px;\n}\n\n.category {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.categoryButton {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  height: 36px;\n  padding: 0 12px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--m-nav-item);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  line-height: 1.2;\n  white-space: nowrap;\n  cursor: pointer;\n  transition:\n    color 0.15s ease,\n    background-color 0.15s ease;\n\n  svg {\n    font-size: 14px !important;\n    color: currentColor;\n    opacity: 0.65;\n    transition:\n      transform 0.15s ease,\n      opacity 0.15s ease;\n  }\n\n  &:hover,\n  &[aria-expanded=\"true\"] {\n    color: var(--m-primary);\n    background: var(--m-primary-subtle);\n\n    svg {\n      opacity: 1;\n    }\n  }\n}\n\n.activeCategory {\n  color: var(--m-primary);\n  background: var(--m-primary-subtle);\n  font-weight: 600;\n\n  svg {\n    opacity: 1;\n  }\n}\n\n.rotatedChevron {\n  transform: rotate(180deg);\n}\n\n.megaMenu {\n  position: fixed;\n  top: 70px;\n  z-index: 40;\n  width: min(760px, calc(100vw - 32px));\n  max-height: calc(100vh - 96px);\n  overflow-y: auto;\n  background: var(--m-header-background-color);\n  border: 1px solid var(--m-border-color);\n  border-radius: 12px;\n  box-shadow:\n    0 18px 45px rgba(15, 23, 42, 0.16),\n    0 3px 8px rgba(15, 23, 42, 0.08);\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    top: -5px;\n    left: var(--menu-arrow-left, 24px);\n    width: 10px;\n    height: 10px;\n    background: var(--m-header-background-color);\n    border-top: 1px solid var(--m-border-color);\n    border-left: 1px solid var(--m-border-color);\n    transform: rotate(45deg);\n  }\n}\n\n.megaMenuInner {\n  padding: 20px;\n}\n\n.megaMenuHeading {\n  margin-bottom: 14px;\n  padding: 0 8px 12px;\n  border-bottom: 1px solid var(--m-border-color);\n  color: var(--m-text);\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.megaMenuGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  align-items: start;\n  gap: 18px;\n}\n\n.megaMenuColumn {\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n  min-width: 0;\n}\n\n.group {\n  min-width: 0;\n  padding: 4px 4px 8px;\n  list-style: none;\n}\n\n.nestedGroup {\n  padding: 10px 0 4px 14px;\n}\n\n.groupTitle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid var(--m-border-color);\n  color: var(--m-text-muted);\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.groupIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: var(--m-primary-subtle);\n  color: var(--m-icon-primary);\n  font-size: 15px;\n}\n\n.menuList {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n}\n\n.menuLink {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 36px;\n  padding: 8px 10px;\n  border-radius: 6px;\n  color: var(--m-text-muted);\n  font-size: 13px;\n  line-height: 1.3;\n  text-decoration: none;\n\n  &::before {\n    content: \"\";\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    flex-shrink: 0;\n    background: currentColor;\n    opacity: 0.55;\n  }\n\n  &:hover {\n    color: var(--m-primary);\n    background: var(--m-primary-subtle-hovered);\n\n    &::before {\n      opacity: 1;\n      background: var(--m-primary);\n    }\n  }\n}\n\n@media (max-width: 1399.88px) {\n  .megaMenu {\n    width: min(680px, calc(100vw - 32px));\n  }\n}\n\n.activeLink {\n  color: var(--m-primary);\n  background: var(--m-primary-subtle);\n  font-weight: 500;\n\n  &::before {\n    opacity: 1;\n    background: var(--m-primary);\n  }\n}\n\n@media (max-width: 1199.88px) {\n  .topNavigation {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topNavigation": `TopNavigation_topNavigation__c2nxx`,
	"category": `TopNavigation_category__7rFD3`,
	"categoryButton": `TopNavigation_categoryButton__cMyCN`,
	"activeCategory": `TopNavigation_activeCategory__jRDIo`,
	"rotatedChevron": `TopNavigation_rotatedChevron__mcsnr`,
	"megaMenu": `TopNavigation_megaMenu__uHslB`,
	"megaMenuInner": `TopNavigation_megaMenuInner__z5CIH`,
	"megaMenuHeading": `TopNavigation_megaMenuHeading__18B3a`,
	"megaMenuGrid": `TopNavigation_megaMenuGrid__xcicp`,
	"megaMenuColumn": `TopNavigation_megaMenuColumn__xkN9p`,
	"group": `TopNavigation_group__tjWg0`,
	"nestedGroup": `TopNavigation_nestedGroup__WmKhu`,
	"groupTitle": `TopNavigation_groupTitle__07BHf`,
	"groupIcon": `TopNavigation_groupIcon__9w4E9`,
	"menuList": `TopNavigation_menuList__adKs9`,
	"menuLink": `TopNavigation_menuLink__5WVcC`,
	"activeLink": `TopNavigation_activeLink__sQJ6F`
};
export default ___CSS_LOADER_EXPORT___;
